import { render, staticRenderFns } from "./KategoriOzellik.vue?vue&type=template&id=30720fe0"
import script from "./KategoriOzellik.vue?vue&type=script&lang=js"
export * from "./KategoriOzellik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports